type Crop = { x: number; y: number; w: number; h: number };
const pct = (n: number) => `${+n.toFixed(4)}%`;

/**
 * Size and offset of the whole source (percent of the box) so that its crop region covers the box without distortion,
 * centred; with the box at the crop's ratio this is exactly the crop. Unknown asset size: the crop is stretched to the box.
 */
export function coverCrop(box: { w: number; h: number }, asset: { w: number; h: number } | null, c: Crop) {
  if (!asset) return { width: pct(100 / c.w), height: pct(100 / c.h), left: pct((-c.x / c.w) * 100), top: pct((-c.y / c.h) * 100) };
  const s = Math.max(box.w / (asset.w * c.w), box.h / (asset.h * c.h)); // world units per source pixel
  const [w, h] = [asset.w * s, asset.h * s];
  const left = -c.x * w - (asset.w * c.w * s - box.w) / 2;
  const top = -c.y * h - (asset.h * c.h * s - box.h) / 2;
  return { width: pct((w / box.w) * 100), height: pct((h / box.h) * 100), left: pct((left / box.w) * 100), top: pct((top / box.h) * 100) };
}

/** The source rectangle (pixels) to draw into a box on a canvas: the crop region, trimmed to the box ratio and centred. */
export function coverSource(src: { w: number; h: number }, c: Crop, box: { w: number; h: number }) {
  const [rx, ry, rw, rh] = [c.x * src.w, c.y * src.h, c.w * src.w, c.h * src.h];
  const ratio = box.w / box.h;
  if (rw / rh > ratio) return { sx: rx + (rw - rh * ratio) / 2, sy: ry, sw: rh * ratio, sh: rh };
  return { sx: rx, sy: ry + (rh - rw / ratio) / 2, sw: rw, sh: rw / ratio };
}
